import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import RouteDetails from './routeDetails';
import AddRoute from './routeHeading';
import Map from './map';
import { Container, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';

const AddNewRoute = () => {
  const [isEditEnabled, setIsEditEnabled] = useState(false);

  useEffect(()=>{
    if(window.location.href.includes("edit-route")){
      setIsEditEnabled(true);
    }
  },[])
  
  return (
    <div style={{ width: '100vw', overflow: 'hidden' }}>
      <Box sx={{ flexGrow: 1, bgcolor: '#F7F9FA', p: '0rem' }}>
      <AddRoute isEditEnabled={isEditEnabled}/>
      </Box>
      <Box component="main" sx={{ flexGrow: 1, bgcolor: '#F7F9FA', p: '2rem' }}>   

        {/* Table Layout */}
        <Paper sx={{
          bgcolor: '#FFFFFF',
          borderRadius: '8px',
          padding: '1.5rem',
          mb: '2rem',
          boxShadow: 2,
        }}>
          <RouteDetails isEditEnabled={isEditEnabled}/>
        </Paper>
      </Box>
    </div>
  );
};

export default AddNewRoute;
